// src/services/api.js
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchProducts = () =>
    axios.get(`${BASE_URL}/products`);

export const fetchProductById = (id) =>
    axios.get(`${BASE_URL}/products/${id}`);
